module.exports = __webpack_public_path__ + "static/img/reliable-icon.6203e650.png";